import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import FMRLogoGraphic from "./FMRLogoGraphic";

/**
 * Shared FMR logo (ROOM MATE style with graphic). Use variant="navbar" in nav, variant="auth" on auth pages.
 * Pass `to` for React Router (e.g. "/fmr") or `href` for external.
 */
const FMRLogo = ({ variant = "navbar", to, href, asLink = true, ...boxSx }) => {
  const isNavbar = variant === "navbar";
  const isAuth = variant === "auth";

  const containerSx = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    color: "inherit",
    flexShrink: 0,
    transition: "transform 0.2s ease, opacity 0.2s ease",
    "&:hover": {
      opacity: 0.9,
      ...(isNavbar && { transform: "scale(1.02)" }),
    },
    ...(isNavbar && {
      width: { xs: 44, md: 48 },
      height: { xs: 44, md: 48 },
      borderRadius: "50%",
      backgroundColor: "#001d3d",
      border: "1px solid rgba(255,255,255,0.2)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      overflow: "hidden",
    }),
    ...(isAuth && {
      width: 80,
      height: 80,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #001d3d 0%, #003566 100%)",
      border: "2px solid rgba(255,255,255,0.2)",
      boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
      overflow: "hidden",
    }),
    ...boxSx,
  };

  const content = <FMRLogoGraphic size={isAuth ? 72 : 40} variant={variant} circular />;

  if (!asLink) {
    return <Box sx={containerSx}>{content}</Box>;
  }
  if (to != null) {
    return (
      <Box component={Link} to={to} sx={containerSx}>
        {content}
      </Box>
    );
  }
  if (href) {
    return (
      <Box component="a" href={href} sx={containerSx}>
        {content}
      </Box>
    );
  }
  return <Box sx={containerSx}>{content}</Box>;
};

export default FMRLogo;
